cb.define([], function() {
  var AA_pc_addressarchiveslist_VM_Extend = {
    doAction: function(name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function(viewmodel) {
      var treeModel = viewmodel.get('pc_addressarchiveslist');
      viewmodel.on('beforeAdd', function(args) {
        if (args.params.params && args.params.params.cParameter == 'child' &&
          args.params.parent) {
          if (args.params.parent.level > 3) {
            cb.utils.alert('地址最多支持4级，已达到最大级次。', 'warning');
            return false;
          }
          //增加子类
          args.params.carryParams.id = args.params.parent.id;
        }
      });
      const Ajax = (args, viewmodel) => {
        var proxy = cb.rest.DynamicProxy.create({
          ensure: {
            url: '/address/changeStatus',
            method: 'POST'
          }
        });
        let id = treeModel.getSelectedNodes()[0].id;
        let path = treeModel.getSelectedNodes()[0].path;
        let ctype, status;
        switch (args.cAction) {
          case "openaddress": // 启用
            ctype = 'forbidden'
            status = false
            break;
          case "closeaddress": // 停用
            ctype = 'forbidden'
            status = true
            break;
          case "openpay": // 支持
            ctype = 'cash'
            status = true
            break;
          case "closepay": // 禁用
            ctype = 'cash'
            status = false
            break;
          default:
        }
        var params = {
          billnum: "pc_product",
          action: args.cAction,
          data: JSON.stringify({id, status, ctype, path})
        }
        proxy.ensure(params, function(err, result) {
          if (err) {
            cb.utils.alert(err.message, 'error');
            return;
          }
          cb.utils.alert(args.cShowCaption + '成功', 'success');
          viewmodel.execute('back')
        });
      }
      viewmodel.on('closeaddress', (args) => {
        Ajax(args, viewmodel)
      })
      viewmodel.on('openaddress', (args) => {
        Ajax(args, viewmodel)
      })
      viewmodel.on('closepay', (args) => {
        Ajax(args, viewmodel)
      })
      viewmodel.on('openpay', (args) => {
        Ajax(args, viewmodel)
      })
      viewmodel.on('beforeBatchdelete', function(args) {
        let node = viewmodel.getTreeModel().getSelectedNodes()[0];
        if (!node.isEnd) {
          cb.utils.alert('存在下级分类，不能删除。', 'warning');
          return false;
        }
        return true;
      });
      const setStatus = function(nodes, status) {
        nodes.map(node => {
          //系统预置项末级、非系统预置项可以新增子项
          if (!(node.initDataEnd || !node.sourcetype) || node.level >= 4) {
            status.push({
              "key": node.id,
              "itemName": "btnAddChild",
              "name": "visible",
              "value": false
            });
          }

          if (node.sourcetype) {
            status.push({
              "key": node.id,
              "itemName": "btnDelete",
              "name": "visible",
              "value": false
            });
          }

          if (node.stopstatus) {
            status.push({
              "key": node.id,
              "itemName": "btnClose",
              "name": "visible",
              "value": false
            });
          } else {
            status.push({
              "key": node.id,
              "itemName": "btnOpen",
              "name": "visible",
              "value": false
            });
          }

          if (node.isCashOnDelivery) {
            status.push({
              "key": node.id,
              "itemName": "btnPayUnstop",
              "name": "visible",
              "value": false
            });
          } else {
            status.push({
              "key": node.id,
              "itemName": "btnPayStop",
              "name": "visible",
              "value": false
            });
          }
          if (node.children)
            setStatus(node.children, status)
        })
      }
      treeModel.on('afterSetDataSource', function(data) {
        let status = []
        setStatus(data, status);
        treeModel.setActionsState(status);
      })
    }
  }
  try {
    module.exports = AA_pc_addressarchiveslist_VM_Extend;
  } catch (error) {

  }
  return AA_pc_addressarchiveslist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_pc_addressarchiveslist_VM.Extend.js